var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocTpl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 76,
    viewBox: "0 0 64 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8C2 3.58172 5.58172 0 10 0H32H47L62 19V38V68C62 72.4183 58.4183 76 54 76H10C5.58172 76 2 72.4183 2 68V8Z",
    fill: "#DEE1E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 42C0 40.8954 0.895431 40 2 40H62C63.1046 40 64 40.8954 64 42V62C64 63.1046 63.1046 64 62 64H2C0.895431 64 0 63.1046 0 62V42Z",
    fill: "#02BB96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6431 58H21.0698V48.0059H17.7744V45.8643H26.9385V48.0059H23.6431V58ZM32.6826 45.8643C34.2487 45.8643 35.3914 46.2018 36.1108 46.877C36.8302 47.5465 37.1899 48.4707 37.1899 49.6494C37.1899 50.1807 37.1097 50.6898 36.9492 51.1768C36.7887 51.6582 36.5259 52.0871 36.1606 52.4634C35.8009 52.8397 35.3195 53.1385 34.7163 53.3599C34.1131 53.5757 33.3688 53.6836 32.4834 53.6836H31.3794V58H28.8062V45.8643H32.6826ZM32.5498 47.9727H31.3794V51.5752H32.2261C32.7075 51.5752 33.1253 51.5116 33.4795 51.3843C33.8337 51.257 34.1076 51.0578 34.3013 50.7866C34.495 50.5155 34.5918 50.1668 34.5918 49.7407C34.5918 49.1431 34.4258 48.7004 34.0938 48.4126C33.7617 48.1193 33.2471 47.9727 32.5498 47.9727ZM39.481 58V45.8643H42.0542V55.875H46.9766V58H39.481Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19H51C48.7909 19 47 17.2091 47 15V5V0L48.5 1.9L62 19Z",
    fill: "#A7AEB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocTpl);
export default __webpack_public_path__ + "static/media/doc_tpl.e9724a00f1459174f379ac62596c9017.svg";
export { ForwardRef as ReactComponent };